// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2R4aY","col":"styles_col__3DuPS","fulfillmentStatus":"styles_fulfillmentStatus__1zgnD","emailCol":"styles_emailCol__1Z16W"};